import styled from "styled-components";
import {ToastClassNames} from "../../../../services/toaster/toast-helpers/toast-classnames.helper";
import {baseColors} from "../../../../themes/definitions/mrgreen/base-colors";
import {ToastContainerDefaultBox} from "./toast-container.default.box";

export const ToastContainerMrGreenBox = styled(ToastContainerDefaultBox)`
    /* how to target the close button */
    .Toastify__close-button.Toastify__close-button--light, .Toastify__close-button.Toastify__close-button--dark, button[aria-label="close"] {
        color: ${({theme}) => theme.colors.brandPrimary};
        opacity: 0.9;
    }

    /* toastClassName */
    .${ToastClassNames.Toast} {
        border: 2px solid ${baseColors.gray183};
        background-color: ${({theme}) => theme.colors.background};
    }

    /* bodyClassName */
    .${ToastClassNames.Body} {
        color: ${({theme}) => theme.colors.brandSecondaryDark};
    }
`;
